import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Switcher } from "@aqar-app/aqar-design-system";
import { useRouter } from "next/router";
import CardContainer from "../../components/cardContainer/cardContainer";
import SignInForm from "./SignInForm";
import SignUpCode from "./SignUpCode";
import styles from "./auth.module.scss";
import SEO from "../../components/seo";
import { STATIC_PAGES_META } from "../../lib/metaDataHelpers";
import { InitialResolver } from "@/lib/use.middlewares";

const Login = ({ otp, signUpChecked }) => {
  const router = useRouter();
  const handleSwitcherChange = (label) => {
    router.replace({
      pathname: label === "إنشاء حساب" ? "/register" : "/login",
      query: router.query,
    });
  };

  const redirectPostLogin = useCallback(() => {
    const { returnTo } = router.query || {};
    if (!returnTo) return router.push("/");
    if (returnTo.includes("http")) {
      window.location.href = returnTo;
    }
    if (returnTo.includes("/haraj/rnpl/")) {
      return (window.location.href = returnTo);
    }
    return router.replace(returnTo);
  }, []);

  const getMessage = () => {
    return router.query?.message;
  };

  const seoProps = (isSignUp) => {
    return isSignUp
      ? STATIC_PAGES_META.signUpPage
      : STATIC_PAGES_META.login(router.query?.returnTo);
  };

  return (
    <>
      <SEO {...seoProps(signUpChecked)} />
      <CardContainer title="انضم إلى عقار" message={getMessage()}>
        <div className={styles.authContainer}>
          <Switcher
            className={styles.switcher}
            labels={["تسجيل دخول", "إنشاء حساب"]}
            defaultChecked={signUpChecked}
            onChange={handleSwitcherChange}
          />
          {signUpChecked ? (
            <SignUpCode redirectPostLogin={redirectPostLogin} />
          ) : (
            <SignInForm otp={otp} redirectPostLogin={redirectPostLogin} />
          )}
        </div>
      </CardContainer>
    </>
  );
};

Login.propTypes = {
  signUpChecked: PropTypes.bool,
  otp: PropTypes.string,
};

Login.defaultProps = {
  signUpChecked: false,
  otp: null,
};
Login.getInitialProps = InitialResolver(async (ctx) => {
  if (ctx.authState) return ctx.redirect("/");
});
export default Login;
